module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"RangeSlider":{"input":{"from":{"label":"Filtrovat cenu od"},"to":{"label":"Filtrovat cenu do"}}}}}')
  delete Component.options._Ctor
}
